import { render, staticRenderFns } from "./AdminView.vue?vue&type=template&id=24e7c042&"
import script from "./AdminView.vue?vue&type=script&lang=ts&"
export * from "./AdminView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports